import { observable, IObservableArray, action, runInAction, computed, makeObservable } from "mobx";
import { API } from "General/API";
import { CoreStore } from "Stores/RESTStore/CoreStore";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { ExtendedDataNode } from "./FoldersStore";

interface Breadcrumb {
  title?: string;
  folderId: number;
  linkId?: number;
}

class BreadcrumbsStore extends CoreStore {
  data: Array<Breadcrumb> = [];

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      clear: action.bound,
      add: action,
      returnToIndex: action,
      changeCrumbs: action.bound,
      init: action.bound,
      setData: action.bound,
      fetch: action.bound,
      currentPathname: computed,
    });
  }

  url(folderId?: number, linkId?: number) {
    return API_URL.FOLDERS.getBreadcrumbs(projectsDataStore.projectId, folderId);
    // Save in case we need to restore it in nearest future
    // let id: number;
    // if (!folderId) {
    //   id = documentsTableStore.rootFolderId;
    // } else {
    //   id = folderId;
    // }
    // if (linkId) {
    //   return API_URL.FOLDERS.getFullPathForExternalLink(projectsDataStore.projectId, linkId);
    // } else {
    //   return API_URL.FOLDERS.getFullPath(projectsDataStore.projectId, id);
    // }
  }

  clear() {
    this.data = [];
  }

  add(item: Breadcrumb) {
    this.data.push(item);
  }

  returnToIndex(index: number) {
    this.data.length = index + 1;
  }

  changeCrumbs({ title, folderId, linkId }: Breadcrumb) {
    if (typeof folderId === "number") {
      const foundItemIdx = this.data.findIndex((crumb) => {
        return crumb.folderId === folderId;
      });
      if (foundItemIdx !== -1) {
        this.returnToIndex(foundItemIdx);
      } else {
        this.add({ title, folderId, linkId });
      }
    } else {
      this.data = [] as IObservableArray<Breadcrumb>;
    }
  }

  async init(folderId?: number, linkId?: number) {
    try {
      let response: API_Breadcrumb[];
      // fi there is not folderId then it's a root folder
      if (!folderId) {
        response = [{ title: projectsDataStore.currentProject.name, id: 0 }];
      } else {
        response = await this.fetch(folderId, linkId);
      }
      runInAction(() => {
        this.data = response.map(({ id, ...item }) => ({ ...item, folderId: id }));
      });
    } catch (error) {
      throw error;
    }
  }

  setData(data: ExtendedDataNode, folderId: number) {
    this.data = this.toBreadCrumbConfig(data, folderId);
  }

  async fetch(folderId: number, linkId?: number) {
    try {
      let params = undefined;
      if (linkId) {
        params = { folder: folderId };
      }
      return await API.getData(this.url(folderId, linkId), params);
    } catch (error) {
      throw error;
    }
  }

  toBreadCrumbConfig(tree: ExtendedDataNode, folderId: number | string): Breadcrumb[] {
    const buffer: Breadcrumb[] = [];

    const traverse = (data: ExtendedDataNode) => {
      let found = undefined;
      if (data.id === folderId) {
        // reached the leaf folder
        return data;
      } else if (data.children) {
        for (const child of data.children) {
          // continue in each child to find the desired leaf folder
          const foundChild = traverse(child);
          if (foundChild) {
            found = child;
            break;
          }
        }
      }
      console.log("found", found);
      if (found) {
        buffer.unshift({ title: found.title as string, folderId: +found.id, linkId: found.linkId });
      }
      return found;
    };
    traverse(tree);
    // always use the root folder
    buffer.unshift({ title: tree.title as string, folderId: +tree.id });
    return buffer;
  }

  get currentPathname() {
    return "/" + this.data.map((item) => item.title).join("/");
  }
}

const breadcrumbsStore = new BreadcrumbsStore();

export { breadcrumbsStore, BreadcrumbsStore };
